import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractObjectUpdateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateWorkOrderSubObjectGql } from '../../workOrderQueries';

const requestId = 'uerUpdateWorkOrderSubObject';

export const useUerUpdateWorkOrderSubObject = (workOrderId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [uerUpdateWorkOrderSubObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerUpdateWorkOrderSubObjectReset(undefined);
        onSuccess?.();
    }, [uerUpdateWorkOrderSubObjectReset, onSuccess]);

    const [
        uerUpdateWorkOrderSubObjectData,
        uerUpdateWorkOrderSubObjectStatus,
        uerUpdateWorkOrderSubObjectError,
        uerUpdateWorkOrderSubObjectRequest,
    ] = useRequest({
        requestId,
        query: uerUpdateWorkOrderSubObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerUpdateWorkOrderSubObjectMakeRequest = useCallback(
        (input: ContractObjectUpdateInput) => {
            dispatch(uerUpdateWorkOrderSubObjectRequest({ workOrderId, input }));
        },
        [uerUpdateWorkOrderSubObjectRequest, dispatch, workOrderId],
    );

    useEffect(() => {
        uerUpdateWorkOrderSubObjectReset(undefined);
    }, [uerUpdateWorkOrderSubObjectReset]);

    return {
        uerUpdateWorkOrderSubObjectData,
        uerUpdateWorkOrderSubObjectStatus,
        uerUpdateWorkOrderSubObjectError,
        uerUpdateWorkOrderSubObjectMakeRequest,
    };
};
